import { Link, Route, Routes } from "react-router-dom";
import RoutesPath from "../../Utils/RoutesPath";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import CoordinatorSidebar from "../CoordinatorSidebar/CoordinatorSidebar";
import CoordinatorNavbar from "../CoordinatorNavbar/CoordinatorNavbar";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import Image from "../../Components/Reusable/Image";
import { useEffect, useState } from "react";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import Calanderimg from "../../assets/images/svg/calenderimg.svg"
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from "react-datepicker";
import CoordinatorApiServices from "../../Services/CoordinatorApiServices";
import FormModal from "../../Components/Modal/Formmodal";
import { handleApiErrors } from "../../Utils/Utils";
import { CirclesWithBar } from "react-loader-spinner";

const CoordinatorDashboard = () => {
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(5);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [purchaselist, setPurchaselist] = useState([]);
  const [balances, setBalance] = useState({});
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  // Functions to open and close the modal
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);


  const handleStartDateChange = (date) => setStartDate(date);
  const handleEndDateChange = (date) => setEndDate(date);

  const CustomDateInput = ({ value, onClick }) => (
    <div className="custom-date-input" onClick={onClick}>
      <input
        type="text"
        placeholder="From"
        value={value}
        readOnly
        className="form-control"
      />
      <img src={Calanderimg} alt="" className="calendar-icon" />
    </div>
  );
  const CustomDateInputTo = ({ value, onClick }) => (
    <div className="custom-date-input" onClick={onClick}>
      <input
        type="text"
        placeholder="To"
        value={value}
        readOnly
        className="form-control"
      />
      <img src={Calanderimg} alt="" className="calendar-icon" />
    </div>
  );

  const getAllPurchaseList = async () => {
    setLoading(true); // Set loading true before API call
    try {
      const response = await CoordinatorApiServices.getAllPurchaseList(
        offset,
        limit,
        startDate,
        endDate,
      );
      setPurchaselist(response.data);
      setBalance(response);

      setAvailableDataCount(response.availableDataCount);
      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    } finally {
      setLoading(false); // Set loading false after API call
    }
  };

  useEffect(() => {
    getAllPurchaseList();
  }, [offset]);
  useEffect(() => {
    const fetchTransactionsByDate = () => {
      if (startDate || endDate) {
        getAllPurchaseList(startDate, endDate);
      }
    };

    const timeoutId = setTimeout(fetchTransactionsByDate, 500); // Debounce the request

    return () => clearTimeout(timeoutId); // Clear timeout if date changes again quickly
  }, [startDate, endDate]);
  const truncateText = (text, charLimit) => {
    if (!text) return "";
    return text.length > charLimit ? text.substring(0, charLimit) + "..." : text;
  };
  return (
    <div className="d-flex">
      <CoordinatorSidebar /> {/* Sidebar component */}
      <div className="mainLayout-content">
        <CoordinatorNavbar /> {/* Navbar component */}
        <div className="main_content_two contentSection scroll_bar">
          <div className="mb-4 d-flex justify-content-between align-items-center">
            <h1 className="black  sub-large-text-one fw-700 mb-0">My Commission</h1>
          </div>
          <div className="mt-3" >
            <div className="row transactioncardsresponsive ">
              <div className="col-md-3 ">
                <div className="transaction-cards  py-3 px-3">
                  <h3 className="small-medium-text fw-500">Total Amount Earned</h3>
                  <div className=" d-flex align-items-center justify-content-between ">
                    <div>
                      <h2 className="Small-Heading fw-700 blue mb-0"><span className="large-transaction-text  blue fw-600">₹</span>&nbsp;{balances.totalAmtEarned}</h2>
                    </div>
                    <div className="totalamount-image-background">
                      <Image src={SvgImages.amount} style={{ width: 30, aspectRatio: 1 }} />
                    </div>

                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="transaction-cards  py-3 px-3">
                  <h3 className="small-medium-text fw-500">Payment Received</h3>
                  <div className=" d-flex align-items-center justify-content-between ">
                    <div>
                      <h2 className="Small-Heading fw-700 blue mb-0"><span className="large-transaction-text  blue fw-600">₹</span>&nbsp;{balances.paymentReceived}</h2>
                    </div>
                    <div className="receivedamount-image-background">
                      <Image src={SvgImages.received} style={{ width: 30, aspectRatio: 1 }} />
                    </div>

                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="transaction-cards  py-3 px-3">
                  <h3 className="small-medium-text fw-500">Balance</h3>
                  <div className=" d-flex align-items-center justify-content-between ">
                    <div>
                      <h2 className="Small-Heading fw-700 blue mb-0"><span className="large-transaction-text  blue fw-600">₹</span>&nbsp;{balances.balanceLeft}</h2>
                    </div>
                    <div className="balanceamount-image-background">
                      <Image src={SvgImages.balance} style={{ width: 30, aspectRatio: 1 }} />
                    </div>

                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="withdrawl-card  py-3 px-3" onClick={handleShowModal}>
                  <div className="d-flex justify-content-center" >
                    <Image src={SvgImages.withdraw} className="withdrawlogo" style={{ aspectRatio: 1 }} />
                  </div>

                  <div className="text-center mt-2">
                    <h2 className="medium-text fw-600 blue mb-0 withdr">Withdraw Request</h2>
                  </div>
                </div>
              </div>
              <FormModal
                showModal={showModal}
                setShowModal={setShowModal}
                title={"Note :"}
                titleone={"You can ONLY request your withdrawal ONCE per week"}
                titletwo={"The minimum amount must be Rs. 1000 or more."}
              />
            </div>
          </div>
          <div className="mt-5 gap-2 mb-2 d-flex flex-wrap justify-content-between align-items-center">
            <h1 className="black  sub-large-text-one fw-700 mb-0">Purchases List</h1>
            <div className="d-flex align-items-center Datesection gap-2">
              <h1 className="small-medium-text fw-600 mb-0">Date</h1>
              <div className="d-flex datepickerstyles gap-3 datepickerstyle">
                <div>

                  <DatePicker
                    selected={startDate}
                    onChange={handleStartDateChange}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="yyyy-MM-dd"
                    isClearable
                    placeholderText="From"
                    maxDate={new Date()}
                    customInput={<CustomDateInput />}
                  />
                </div>
                <div>
                  <DatePicker
                    selected={endDate}
                    onChange={handleEndDateChange}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="yyyy-MM-dd"
                    isClearable
                    placeholderText="To"
                    minDate={startDate}
                    maxDate={new Date()}
                    customInput={<CustomDateInputTo />}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="table_container" style={{ display: "block" }}>

            <div className="table_title">
              <div className="table_headings mt-2 Commonclass">
                <h1 className="black fs-18 fw-600 mb-0">
                </h1>
              </div>
              {loading ? (
                <div className="text-center d-flex justify-content-center">
                  <CirclesWithBar
                    height="80"
                    width="80"
                    color="#F6821F"
                    ariaLabel="bars-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                  />
                </div>
              ) : (
                <>
                  {
                    purchaselist.length === 0 ? (
                      <div className="no-records-container-coordinator text-center" >
                        <div className="no-record-image " >
                          <Image src={PngImages.no_record} className="img-fluid" />
                        </div>
                        <p className="no-records-text sub-large-text-one fw-700 mb-4">No records found</p>
                        {/* <div className="d-flex justify-content-center">
                    <SubmitButtonTwo title={"Go to Packages"} className=" Package-button mb-4"></SubmitButtonTwo>
                  </div> */}

                      </div>
                    ) : (
                      <div className="Tableorderhistory tablebordernone" style={{ overflowX: "auto" }}>
                        <table
                          className="table  tablecoordinator mb-0 pt-3"
                          id="dtHorizontalExample"
                          cellSpacing="0"
                          width="100%"
                        >
                          <thead style={{ backgroundColor: '#F5F5F5' }}>
                            <tr >
                              <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "10%" }}>
                                Sr No.
                              </th>
                              <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "10%" }}>
                                Name Of Student
                              </th>
                              <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "10%" }}>
                                Email ID
                              </th>
                              <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "10%" }}>
                                Mobile Number
                              </th>
                              <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "10%" }}>
                                Package Name
                              </th>
                              <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "10%" }}>
                                Price
                              </th>
                              <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "10%" }}>
                                Date/Time
                              </th>
                              <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "10%" }}>
                                Commission In %
                              </th>
                              <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "10%" }}>
                                Commission Amount
                              </th>

                            </tr>
                          </thead>
                          <tbody className="bg_light">
                            {purchaselist.map((item, index) => (
                              <tr key={index} className="table_heading">
                                <td className="small-medium-text fw-600 " style={{ paddingLeft: '40px' }}>{limit * offset + (index + 1)}</td>
                                <td className="small-medium-text fw-600">{item.studentName}</td>
                                <td className="small-medium-text fw-600">{item.email}</td>
                                <td className="small-medium-text fw-600">{item.mobile}</td>
                                <td className="small-medium-text  fw-600" title={item.packageName}>{truncateText(item.packageName)}</td>
                                <td className="small-medium-text  fw-600">{item.price}</td>
                                <td className="small-medium-text  fw-600">{item.date}</td>
                                <td className="small-medium-text  fw-600">{item.coordinatorPer}</td>
                                <td className="small-medium-text  fw-600">{item.amount}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                      </div>

                    )
                  }
                </>)}

            </div>

          </div>
          <div className="row mt-3 align-items-center parentcustomnavbtn">
            <div className="col-md-6  col-sm-6 ">     <p className=" small-text fw-500 mb-0" style={{ opacity: '0.5', fontStyle: "italic" }}>
              {availableDataCount > 0
                ? `Showing ${Math.min(offset * limit + 1, availableDataCount)} to ${Math.min((offset + 1) * limit, availableDataCount)} of ${availableDataCount} entries`
                : "Showing No Entries"}</p>
            </div>
            <div className="col-md-6  col-sm-6 pagebtnrespo">  {generatePaginationFooter(
              availableDataCount,
              limit,
              offset,
              setOffset
            )}</div>

          </div>


        </div>
      </div>
    </div>




  );
};

export default CoordinatorDashboard;
